/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingQuerySeverity extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSecurityHubFindingQuerySeverity");
    }

    getFixupPrototypeFunction() { return AwsSecurityHubFindingQuerySeverity.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingQuerySeverity>): AwsSecurityHubFindingQuerySeverity {
        let obj = Object.assign(new AwsSecurityHubFindingQuerySeverity(), model);
        AwsSecurityHubFindingQuerySeverity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingQuerySeverity>): AwsSecurityHubFindingQuerySeverity {
        if (!model) return null;
        return AwsSecurityHubFindingQuerySeverity.newInstance(<AwsSecurityHubFindingQuerySeverity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingQuerySeverity) {
        if (!obj) return;

        models.AwsSecurityHubFindingQuerySeverity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingQuerySeverity): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSecurityHubFindingQuerySeverity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Severities for the findings
     */
    severities: Array<string>;

}
